import { FeatureConfiguration } from "..";
import { reducer } from "./reducers";
import { locationMiddleware } from "./middleware/locationMiddleware";

export default function (config: FeatureConfiguration) {
    config.reducers.location = reducer;
    config.middleware.push(locationMiddleware());
}
